<template>
    <v-container fluid class="down-top-padding">
        <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
        <v-row>
            <v-col cols="12" lg="12">
                <v-card>
                    <v-card-text class="pa-5 border-bottom">
                        <center><h2>MONITOREO</h2></center>
                    </v-card-text>
                    <v-card-text class="pa-5 border-bottom">
                        <form>
                            <v-row>
                                <v-col cols="12" sm="1" lg="3" style="padding: 0px 12px;">
                                    <v-autocomplete :items="redes" label="Red" v-model="red"  @change="updateRed" placeholder="Todas las redes" item-text="Nombre" item-value="Id" multiple dense  outlined clearable required></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="1" lg="1" style="padding: 0px 12px;">
                                    <v-autocomplete :items="anios" v-model="anio" label="Año" @change="updateAnio" dense  outlined required></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="1" lg="1" style="padding: 0px 12px;">
                                    <v-autocomplete :items="meses" v-model="mes" label="Mes" item-text="Nombre" item-value="Id" multiple dense  outlined clearable required>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip v-if="index === 0">
                                            <span>{{ item.Nombre }}</span>
                                            </v-chip>
                                            <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                            >(+{{ mes.length - 1 }} Meses)</span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" lg="2" style="padding: 0px 12px;">
                                    <v-autocomplete :items="cursosVidas" v-model="cursoVida" label="Curso de Vida" @change="updateCursoVida" item-text="name" item-value="id" dense  outlined required></v-autocomplete>
                                </v-col>
                                <v-col v-show="cursoVida === 2" cols="12" sm="12" lg="2" style="padding: 0px 12px;">
                                    <v-autocomplete :items="gruposEtareos" v-model="grupoEtareo" label="Grupo Etareo" item-text="name" item-value="id" @change="updateSubCursoVida" dense  outlined required></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="1" lg="3" style="padding: 0px 12px;">
                                    <v-autocomplete :items="indicadores" v-model="indicador" label="Indicador" item-text="name" item-value="id" dense @change="updateIndicador" outlined required></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="1" lg="2" style="padding: 0px 12px;">
                                    <v-btn :disabled="indicador == ''" color="info" class="white--text" style="width:100%" @click="buscar">
                                        <v-icon left dark>mdi-magnify</v-icon> Buscar
                                    </v-btn>
                                </v-col>
                            </v-row>
                            
                        </form>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" lg="12" v-if="renderComponent">
                <v-card>
                    <v-card-text>
                        <form>
                           <HMultiple v-if="datosIndicador != null" :serie="datosIndicador.series" :denominador="datosIndicador.denominador" :numerador="datosIndicador.numerador" :avance="datosIndicador.avance" :titulo="titulo"></HMultiple>
                        </form>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" lg="12" v-if="renderComponent2">
                <v-card>
                    <v-card-text>
                        <form>
                            <HMultiple v-if="datosIndicador2 != null" :serie="datosIndicador2.series" :denominador="datosIndicador2.denominador" :numerador="datosIndicador2.numerador" :avance="datosIndicador2.avance" :titulo="titulo"></HMultiple>
                        </form>
                    </v-card-text>
                </v-card>
            </v-col>
            
        </v-row>
        
    </v-container>
</template>

<script>

import axios from 'axios';
import CursosVidasResource from '@/apis/cursoVida';
const cursosVidasResource = new CursosVidasResource()
import CargasResource from '@/apis/cargas';
const cargasResource = new CargasResource()

export default {
  name: "Monitoreo",
  data: () => ({
      page: {
      title: "Seguimiento Administrativo",
      icon: "mdi-adjust",
    },
    breadcrumbs: [
      {
        text: "Tablero de Mando",
        disabled: false,
        to: "/"
      },
      {
        text: "Resumen",
        disabled: true
      }
    ],
    overlay: false,
    ficha: null,
    dialog: false,
    tabla: [],
    unidades: [],
    reporte: 0,
    red: '',
    redes: [],
    mes: [],
    mesActual: '',
    mesActual1: '',
    microred: '',
    microredes: [],
    establecimientos: [],
    establecimiento: '',
    estrategias: [],
    indicador: 1,
    indicadores: [],
    anios: [],
    anio: null,
    idFicha: 1,
    cursoVida: 1,
    cursosVidas: [],
    grupoEtareo: 0,
    gruposEtareos: [],
    datosIndicador: [],
    datosIndicador2: [],
    renderComponent: false,
    renderComponent2: false,
    renderComponent3: false,
    titulo: false,
    status(status) {
      const statusMap = {
        4: 'info',
        1: 'success',
        2: 'warning',
        3: 'danger'
      }
      return statusMap[status]
    },
    search: {
        categoria: [],
        unidad: [],
        mes: '',
        anio: '',
        red: [],
        microred: [],
        establecimiento: [],
        estrategia: [],
        cursoVida: 1,
        cursosVidas: [],
        indicador: '',
        indicadores: []
      },
      meses: [],
      mesesTemp2: [
      {
        Id: 1,
        Nombre: 'Enero'
      },
      {
        Id: 2,
        Nombre: 'Febrero'
      },
      {
        Id: 3,
        Nombre: 'Marzo'
      },
      {
        Id: 4,
        Nombre: 'Abril'
      },
      {
        Id: 5,
        Nombre: 'Mayo'
      },
      {
        Id: 6,
        Nombre: 'Junio'
      },
      {
        Id: 7,
        Nombre: 'Julio'
      },
      {
        Id: 8,
        Nombre: 'Agosto'
      },
      {
        Id: 9,
        Nombre: 'Septiembre'
      },
      {
        Id: 10,
        Nombre: 'Octubre'
      },
      {
        Id: 11,
        Nombre: 'Noviembre'
      },
      {
        Id: 12,
        Nombre: 'Diciembre'
      }
    ],
    mesesTemp3: [
      {
        Id: 1,
        Nombre: 'Enero'
      },
      {
        Id: 2,
        Nombre: 'Febrero'
      },
      {
        Id: 3,
        Nombre: 'Marzo'
      },
      {
        Id: 4,
        Nombre: 'Abril'
      },
      {
        Id: 5,
        Nombre: 'Mayo'
      },
      {
        Id: 6,
        Nombre: 'Junio'
      },
      {
        Id: 7,
        Nombre: 'Julio'
      },
      {
        Id: 8,
        Nombre: 'Agosto'
      },
      {
        Id: 9,
        Nombre: 'Septiembre'
      },
      {
        Id: 10,
        Nombre: 'Octubre'
      },
      {
        Id: 11,
        Nombre: 'Noviembre'
      },
      {
        Id: 12,
        Nombre: 'Diciembre'
      }
    ],
    categorias: [],
    tituloIndicadorGrafico: '',
  }),
  components: {
    HMultiple: () => import('./dashboards/Graficos/Multiple/HMultiple'),
  },
  mounted() {
    this.cargarCurso()
  },
  created() {
    this.cargarCurso()
    this.getAnios()
    this.getRedes()
    this.getMicroRedes()
    this.getEstablecimientos()
    this.getCursosVida()
    this.getGrupoEtareo()
    this.getIndicador()
  },
  methods: {
    cargarCurso(){
      if(this.$store.state.curso != 1){
        this.cursoVida = this.$store.state.curso
      }
      if(this.$store.state.grupo != 0){
        this.grupoEtareo = this.$store.state.grupo
      }
    },
    async getAnios(){
        this.overlay = true
      await cargasResource.fetchAnios().then(response => {
          this.anios = response
      })
      this.getAnio()
    },
    async getAnio(){
      await cargasResource.fetchAnioMax().then(response => {
          const anio = response
          this.anio = anio.toString()
      })
      this.getMeses()
    },
    async getMes(){
      await cargasResource.fetchMesMax(this.anio).then(response => {
          let mes = response
          this.mesActual = mes;
          this.mesActual1 = mes-1;
      })
    },
    async getMeses(){
      await cargasResource.fetchMeses(this.anio).then(response => {
          let meses = response
          this.meses = []
          for (var i = 0; i < meses.length; i++) {
            let cant = parseInt(meses[i])
            this.meses.push(this.mesesTemp2.find(x => x.Id === cant));
          }
          this.overlay = false
      })
    },
    semaforo(num){
      if (num>=0.9) {
        return 'mdi mdi-checkbox-blank-circle green--text'
      } else if (num<0.9 && num>=0.75) {
        return 'mdi mdi-mdi mdi-triangle orange--text'
      }else if (num<0.75) {
        return 'mdi mdi-rotate-135 mdi-checkbox-blank red--text'
      }
    },
    async getFicha(){
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/fichas/'+this.indicador).then(response => {
          this.ficha = response.data
        })
    },
    async getResumenIndicadorRedes(){
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/indicadoresEstablecimiento/'+this.indicador,{
            params: {
                mes: this.mes,
                ambito: 1,
                anio: this.anio,
            }
        }).then(response => {
            this.datosIndicador = response.data
            this.forceRerender()
        })
    },
    async getResumenIndicadorMicroRedes(){
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/indicadoresEstablecimiento/'+this.indicador,{
            params: {
                mes: this.mes,
                anio: this.anio,
                ambito: 1,
                red: this.red
            }
        }).then(response => {
            this.datosIndicador2 = response.data

             this.forceRerender2()
        })
    },
    forceRerender() {
        // Remove my-component from the DOM
        this.renderComponent = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent = true;
        });
    },
    forceRerender2() {
        // Remove my-component from the DOM
        this.renderComponent2 = false;

        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent2 = true;
        });
    },
    async validate () {
        await this.axios.get(this.$api_url + '/tablero/inicio',{
                params: {
                    establecimiento: this.verifica(this.search.establecimiento),
                    mes: this.verifica(this.search.mes),
                    anio: this.verifica(this.search.anio),
                    unidad: this.verifica(this.search.unidad),
                    red: this.verifica(this.search.red),
                    microred: this.verifica(this.search.microred),
                    estrategia: this.search.estrategia
                }
            }).then(response => {
            this.tabla = response.data
        })
    },
    showMsgFromChild:function(data){
        this.reporte = data
    },
    async buscar(){
      console.log(this.indicadores);
      console.log('indicador')
      let n = this.indicadores.findIndex(object => {
          return object.id === this.indicador;
        });
      console.log(n);
        this.titulo =this.indicadores[n].name
        this.getFicha()
        this.datosIndicador1 = []
        this.getResumenIndicadorRedes()
        if(this.red.length > 0){
            this.getResumenIndicadorMicroRedes()
        }
        else{
            this.datosIndicador2 = []
        }
    },
    async getUnidades() {
        await this.axios.get(this.$api_url + '/filtros').then(response => {
            this.unidades = response.data.unidad,
            this.redes = response.data.red,
            this.microredes = response.data.microred,
            this.establecimientos = response.data.establecimiento,
            this.categorias = response.data.categoria
        })
    },
    async getEstrategias() {
        await this.axios.get(this.$api_url + '/filtros/estrategias').then(response => {
            this.estrategias = response.data
        })
    },
    async getRedes(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/filtros/redes').then(response => {
          this.redes = response.data
      })
    },
    async getMicroRedes(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/filtros/microredes',{
          params: {
              red: this.red,
          }
      }).then(response => {
          this.microredes = response.data
      })
    },
    async getEstablecimientos(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/filtros/establecimientos',{
          params: {
              red: this.red,
              microred: this.microred,
          }
      }).then(response => {
          this.establecimientos = response.data
      })
    },
    async getCursosVida(){
      await cursosVidasResource.fetchCursosVidas().then(response => {
            this.cursosVidas = response
      })
    },
    async getGrupoEtareo(){
      await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/subcursosVidas')
      .then(response => {
            this.gruposEtareos = response.data
        })
    },
    async getIndicador(){
      this.indicador = '';
      if(this.cursoVida !== undefined){
        if(this.grupoEtareo === undefined){
          this.grupoEtareo = 0;
        }
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/indicadoresxCV/'+this.cursoVida+'/'+this.grupoEtareo)
        .then(response => {
              this.indicadores = response.data
        })
      }
    },
    updateRed(){
      this.getMicroRedes();
      this.getEstablecimientos();
      this.microred = []
      this.establecimiento = []
    },
    updateMicroRed(){
      this.getEstablecimientos();
      this.establecimiento = []
    },
    updateEstablecimiento(){
    }, 
    updateCursoVida(){
        this.getIndicador()
    }, 
    updateSubCursoVida(){
        this.getIndicador()
    }, 
    updateIndicador(){
        this.tituloIndicadorGrafico = this.indicador
    },
    updateAnio(){
      this.getMeses()
    },
  }
};
</script>
